export * from './fraud';
export * from './money';
export * from './card-expiry-date';
export * from './types';

export enum HardBlockReason {
    LOST = 'LOST',
    STOLEN = 'STOLEN',
    DAMAGED = 'DAMAGED',
    NOT_IN_USE = 'NOT_IN_USE',
}

export enum InvoiceType {
    INVOICE = 'INVOICE',
    OVERDUE_NOTICE = 'OVERDUE_NOTICE',
    YEARLY_STATEMENT = 'YEARLY_STATEMENT',
    CHANGE_NOTICE = 'CHANGE_NOTICE',
    AGREEMENT_TERMS_CHANGE = 'AGREEMENT_TERMS_CHANGE',
    NOTIFICATION = 'NOTIFICATION',
    UNKNOWN = 'UNKNOWN',
}
